/**
 * Replaces an item in an array.
 *
 * @param {Array} array - The array.
 * @param {number} index - The index of the item to be substituted.
 * @param {any} item - The new item.
 * @returns {Array}
 */
const arrayReplaceItem = (array, index, item) => {
  if (!array[index]) {
    return array;
  }

  const clone = [...array];
  clone[index] = item;

  return clone;
};

export default arrayReplaceItem;
